import { render, staticRenderFns } from "./AbasResultado.vue?vue&type=template&id=27c4155e&scoped=true&"
import script from "./AbasResultado.vue?vue&type=script&lang=js&"
export * from "./AbasResultado.vue?vue&type=script&lang=js&"
import style0 from "./AbasResultado.vue?vue&type=style&index=0&id=27c4155e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4155e",
  null
  
)

export default component.exports